import React, {useEffect} from 'react';
import NavXCSI from "../../layout/respnsivenavigation/nav-xsci";
import {useLocation} from 'react-router-dom';
import FooterXsci from "../../layout/footer/footer-xsci";
import webdesignstyles from "./services.webdesign.module.css";
import responsive from "./service-web-design-responsive.module.css"
import HeroBanner from "../../common/herobanner/hero-banner";
import img from "./images/web-design-banner-image.jpg";
import CenteredPageContainer from "../../common/centeredcontainer/centered-page-container";
import webdesign from "./images/webdesign.jpg";
import CTAButton from "../../common/ctabutton/cta-button";
import Lazy from "../../common/imagescroll/Lazy";
import KeyFeatures from "./keyfeatures/keyFeatures";
import {useTranslation} from "react-i18next";
import Hero from "./hero/hero";
import Process from "./process/process";
import WhyChooseService from "./whyChooseService/whyChooseService";
import TechStack from "./techStack/techStack";
import CTASection from "./ctaSection/ctaSection";
import DiagonalSection from "../../diagonalSection/diagonalSection";

const ServicesWebDesign: React.FC = () => {

    const location = useLocation();

    const { t, i18n } = useTranslation(); // Use the translation hook

    const pageTitle = "Custom Web Design & SEO ServicesSection in Kanata - XSCI";
    const metaDescriptionContent = "XSCI offers affordable, flexible custom web design & SEO services in Kanata. " +
        "Grow your business with responsive, user-friendly websites. Get started today!";

    useEffect(() => {
        // Change the background color when this page is loaded
        document.body.style.backgroundColor = 'white';

        // Cleanup the effect when leaving this page (optional)
        return () => {
            document.body.style.backgroundColor = ''; // Reset background color when leaving
        };
    }, [location]);

    useEffect(() => {
        document.title = pageTitle;

        // Set the meta description
        let metaDescription = document.querySelector("meta[name='description']") as HTMLMetaElement;

        // The content you're trying to use for the meta description
        const descriptionContent = metaDescriptionContent;

        if (metaDescription) {
            metaDescription.setAttribute("content", descriptionContent); // Correctly set the content
        } else {
            metaDescription = document.createElement("meta") as HTMLMetaElement;
            metaDescription.name = "description";
            metaDescription.content = descriptionContent;
            document.head.appendChild(metaDescription);
        }
    }, []);


    return (
        <>
            <NavXCSI />
            <Hero/>
            <KeyFeatures/>
            <WhyChooseService/>
            <Process/>
            <DiagonalSection/>
            <CTASection
                text={"Tell us what you need."}
                subText={"We’ll help you figure out the rest."} />
            <FooterXsci/>
        </>
    );
};

export default ServicesWebDesign;
